import { useEffect, useRef } from 'react';

import useOnScreen from '../../../utilz/useOnScreen';
import ContentSpinner from '../Spinners/ContentSpinner';

const ScrollPagination = ({
  children,
  className = '',
  loadMore = () => {},
  scrollOffset = 0,
  hasMore = true,
  isLoading = false,
  getByRef = undefined,
  loadingText = '',
  hideSpinner = false,
  spinnerSize = 'large',
  disabledForceNextPage = false,
  isSkipScrollToBottom = false,
}) => {
  const scrollRef = useRef();

  if (scrollRef && getByRef) {
    getByRef(scrollRef);
  }

  const handleScroll = (e) => {
    if (Math.round(e.target.scrollTop + scrollRef.current.clientHeight) >= e.target.scrollHeight - scrollOffset) {
      loadMore();
    }
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO: fix
  useEffect(() => {
    if (scrollRef && isLoading && !isSkipScrollToBottom) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [isLoading, scrollRef]);

  const isScrollContentOnScreen = useOnScreen(scrollRef);

  // trigger load more if scroll height is not there
  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO: fix
  useEffect(() => {
    if (scrollRef && !isLoading && !disabledForceNextPage && isScrollContentOnScreen) {
      const hasVerticalScrollbar = scrollRef.current.scrollHeight > scrollRef.current.clientHeight;
      if (!hasVerticalScrollbar && !isLoading && hasMore) {
        loadMore();
      }
    }
  }, [hasMore, isLoading, scrollRef, disabledForceNextPage, isScrollContentOnScreen]);

  const isLoadingHandler = () => (
    <div className={`py-16 ${hideSpinner ? 'd-none' : ''}`}>
      <ContentSpinner size={spinnerSize} height="auto" />
      {loadingText && (
        <h3 className="text-center mt-10">
          <b>{loadingText}</b>
        </h3>
      )}
    </div>
  );

  return (
    <div
      className={`custom-scroll-bar ${className || ''}`}
      ref={scrollRef}
      {...(hasMore && !isLoading ? { onScroll: handleScroll } : {})}
    >
      {children}
      {isLoading && isLoadingHandler()}
    </div>
  );
};

export default ScrollPagination;
